import { StandardEvents } from '@shopify/events';

/**
 * <ym-product-sync data-ym-key="..."> keeps a ym- product block in step with the
 * selected variant. Horizon's variant picker only morphs itself and lets each block
 * pull its own markup from the fetched section HTML (see product-price.js); this does
 * the same for Yard Mint blocks whose content depends on the variant (facts, edition).
 */
class YmProductSync extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    this.#controller?.abort();
    this.#controller = new AbortController();
    section.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        const html = detail?.html;
        const key = this.dataset.ymKey;
        if (!html || !key) return;
        const next = html.querySelector(`ym-product-sync[data-ym-key="${CSS.escape(key)}"]`);
        if (next && next.innerHTML !== this.innerHTML) this.innerHTML = next.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[ym-product-sync]', error);
      });
  };
}

if (!customElements.get('ym-product-sync')) customElements.define('ym-product-sync', YmProductSync);
